var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scroll-div scroll-div-country" },
    [
      _c(
        "div",
        { class: _vm.countryChart ? "chart-display" : "chart-notdisplay" },
        [
          _c("div", { staticClass: "chart-title col-md-12" }, [
            _vm.initialCallsDone
              ? _c("span", { staticClass: "desk_chart_title" }, [
                  _vm._v("Number of registrations by country"),
                ])
              : _vm._e(),
            _vm.initialCallsDone
              ? _c(
                  "span",
                  {
                    staticClass: "mob_chart_title",
                    class: _vm.boldHeader ? "bold_header" : "",
                  },
                  [_vm._v("Number of Registrations by Country")]
                )
              : _vm._e(),
            _vm.isRemoveIcon
              ? _c(
                  "span",
                  { staticClass: "remove_icon", on: { click: _vm.removeIcon } },
                  [
                    _c("img", {
                      attrs: {
                        src: "/static/images/icons/remove_icon.svg",
                        alt: "remove-icon",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
          _vm.isDisplayHeader
            ? _c("div", { staticClass: "row" }, [
                _vm.initialCallsDone
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-5 col-md-5 col-sm-5 col-xs-9 chart-select",
                      },
                      [
                        _vm._m(0),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-9 col-xs-12 customdrp all_customdrp_chart overflow-y-auto-reports",
                          },
                          [
                            _c(
                              "multiselect",
                              {
                                staticClass:
                                  "multiselect-single-dropdown multiselect-multiple",
                                attrs: {
                                  showLabels: false,
                                  "close-on-select": false,
                                  placeholder: "Product",
                                  label: "productName",
                                  "track-by": "productName",
                                  multiple: true,
                                  searchable: true,
                                  "clear-on-select": false,
                                  options: _vm.dataProduct,
                                  value: _vm.selectedStackCount,
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.reRenderChart("stack")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function ({ values, isOpen }) {
                                        return _c(
                                          "div",
                                          { staticClass: "selection-count" },
                                          [
                                            !isOpen &&
                                            values.length ==
                                              _vm.dataProduct.length
                                              ? [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/filter.svg",
                                                      alt: "filter-icon",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "selected-count",
                                                    },
                                                    [_vm._v("All")]
                                                  ),
                                                ]
                                              : !isOpen
                                              ? [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/filter.svg",
                                                      alt: "filter-icon",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "selected-count",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(values.length) +
                                                          " Selected"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : isOpen
                                              ? [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/filter.svg",
                                                      alt: "filter-icon",
                                                    },
                                                  }),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return _c("span", {}, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex",
                                              on: {
                                                input: function ($event) {
                                                  return _vm.toggleCBValue(
                                                    "stack",
                                                    props.option
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "checkbox inline-checkbox",
                                                },
                                                [
                                                  _c("label", [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        value:
                                                          props.option
                                                            .productName,
                                                        checked:
                                                          props.option.selected,
                                                      },
                                                    }),
                                                    _c("span", {
                                                      staticClass: "cr",
                                                      class:
                                                        props.option
                                                          .productName ==
                                                          "All" &&
                                                        props.option.selected
                                                          ? "selected-all"
                                                          : "",
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleCBValue(
                                                        "stack",
                                                        props.option
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.option.productName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  554202054
                                ),
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult",
                                  },
                                  [_vm._v("No matching data")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.initialCallsDone &&
                _vm.permissions.indexOf("EXPORT_REPORT_EXPIRATION_BY_COUNTRY") >
                  -1
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-2 col-lg-push-5 col-md-2 col-sm-2 col-sm-push-5 col-md-push-5 col-xs-3 ml-xs-37",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn emergo-white-button",
                            attrs: { disabled: _vm.disableBarChartExport },
                            on: {
                              click: function ($event) {
                                return _vm.exportPopup(_vm.stackedBarChartId)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "margin-btn-plus-icon",
                              attrs: {
                                src: "/static/images/icons/icon_share.svg",
                                alt: "share-icon",
                              },
                            }),
                            _vm._v(" Export "),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.initialCallsDone
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-5 col-lg-pull-2 col-md-5 col-sm-5 col-xs-12 col-sm-pull-2 col-md-pull-2 horizontal_legend_country_stack mt-10",
                        attrs: { id: "legend2" },
                      },
                      [
                        _c("span", { staticClass: "key_dot legend_active" }),
                        _c("span", { staticClass: "legend_name" }, [
                          _vm._v("Active"),
                        ]),
                        _c("span", { staticClass: "key_dot legend_pending" }),
                        _c("span", { staticClass: "legend_name" }, [
                          _vm._v("Pending"),
                        ]),
                        _c("span", { staticClass: "key_dot legend_expsoon" }),
                        _c("span", { staticClass: "legend_name" }, [
                          _vm._v("Expiring soon"),
                        ]),
                        _c("span", { staticClass: "key_dot legend_expired" }),
                        _c("span", { staticClass: "legend_name" }, [
                          _vm._v("Expired"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.initialCallsDone
            ? _c("div", { staticClass: "view_btn" }, [
                _vm.isBtnView
                  ? _c(
                      "button",
                      {
                        staticClass: "btn emergo-white-button wd-90",
                        on: { click: _vm.viewbtn },
                      },
                      [_vm._v(" View ")]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("div", {
            staticClass: "stacked-bar-Chart",
            attrs: { id: "stackedBarChartDiv" },
          }),
        ]
      ),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c(
        "div",
        { class: _vm.mapChart ? "chart-display" : "chart-notdisplay" },
        [
          _c("div", { staticClass: "chart-title" }, [
            _vm.initialCallsDone
              ? _c("span", { staticClass: "desk_chart_title" }, [
                  _vm._v("Registration map"),
                ])
              : _vm._e(),
            _vm.initialCallsDone
              ? _c(
                  "span",
                  {
                    staticClass: "mob_chart_title",
                    class: _vm.boldHeader ? "bold_header" : "",
                  },
                  [_vm._v("Registration Map")]
                )
              : _vm._e(),
            _vm.isRemoveMapIcon
              ? _c(
                  "span",
                  {
                    staticClass: "remove_icon",
                    on: { click: _vm.removeMapIcon },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/static/images/icons/remove_icon.svg",
                        alt: "remove-icon",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
          _vm.isDisplayMapHeader
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 p-15" },
                  [
                    _c("new-map-view", {
                      attrs: { permissions: _vm.permissions },
                      on: {
                        setMapData: _vm.setMapData,
                        exportDocumentId: _vm.exportPopup,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c("loader", { attrs: { loadingStatus: _vm.chartLoaderStatus } }),
      _c("registration-details-popup", {
        attrs: {
          permissions: _vm.permissions,
          dataRow: _vm.activeRegistration,
          archivedFlag: _vm.archivedFlag,
          reportFlag: _vm.reportFlag,
        },
        on: { hidePopup: _vm.hidePopup },
      }),
      _c("permission-access-modal"),
      _c("export-popup", {
        attrs: { documentId: _vm.documentId },
        on: { resetExportPopup: _vm.resetExportPopup },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-2 col-md-2 col-sm-3 col-xs-10 chart-sub-content" },
      [_c("label", { staticClass: "sub-content" }, [_vm._v("Products")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }